<template>
  <v-container fluid>
    <data_table
      :displayname="'Serial Inventory'"
      :options="false"
      :loader="get_data_load"
      :headers="headers"
      :search_text="'Search (Serial Number, Item Number, Location etc..)'"
      :items="items"
      :defaultSort="'Serial_Number'"
    >
      <template v-slot:actions>
        <v-btn icon dark @click="exportExcel" :disabled="!items.length">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs">mdi-microsoft-excel</v-icon>
            </template>
            <span>Export Excel</span>
          </v-tooltip>
        </v-btn>
      </template>
    </data_table>
  </v-container>
</template>

<script>
import data_table from '@/components/data_table.vue'
import { mapGetters } from 'vuex'
import { globalMixin } from '@/mixins/global_functions.js'
import { json2excel } from 'js2excel'
import axios from 'axios'

export default {
  name: 'SerialInventory',
  mixins: [globalMixin],
  components: {
    data_table
  },
  data () {
    return {
      items: [],
      headers: [
        { text: 'Serial Number', value: 'Serial_Number' },
        { text: 'Item Number', value: 'Item_No', filterEnabled: true },
        { text: 'Pipe Length', value: 'KWP_Length' },
        { text: 'Current Location', value: 'Current_Location', filterEnabled: true },
        { text: 'Inspection Date', value: 'Inspection_Date_Formatted' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getUsername'])
  },
  methods: {
    cleanLocation (location) {
      return (location || '').replace(/_/g, ' ')
    },
    exportExcel () {
      if (!this.items.length) return
      const rows = this.items.map(row => ({
        'Serial Number': row.Serial_Number,
        'Item Number': row.Item_No,
        'Pipe Length': row.KWP_Length,
        'Current Location': row.Current_Location,
        'Inspection Date': row.Inspection_Date_Formatted
      }))
      try {
        json2excel({
          data: rows,
          name: 'Serial Inventory',
          formateDate: 'dd/mm/yyyy'
        })
      } catch (e) {
        console.error('Export to Excel failed:', e)
      }
    }
  },
  mounted () {
    this.set_data_load(true)
    axios
      .get('/getSerialInventory', {
        params: { username: this.getUsername }
      })
      .then(response => {
        this.items = response.data.map(row => ({
          ...row,
          Current_Location: this.cleanLocation(row.Current_Location),
          Inspection_Date_Formatted: this.$formatDate(row.Inspection_Date)
        }))
      })
      .catch(err => console.error('Error fetching serial inventory:', err))
      .finally(() => {
        this.set_data_load(false)
      })
  }
}
</script>
